export default __webpack_public_path__ + "locales/pl/DeleteDialog.json?hash=16873c9f5fb85d67bcce83c15e5393de";